import React from "react";
import { MenuGroupPreviewContainer } from "../../styled/setting";

const MenuGroupPreview = ({ menuGroup }) => {
  return (
    <MenuGroupPreviewContainer>
      <div className="tit">
        <span>메뉴그룹 미리보기</span>
      </div>
      <div className="cont">
        <div className="products">
          <span>{menuGroup?.name || ""}</span>
          {menuGroup.products.map((item) => (
            <div className="product">
              <img
                src={imgHandler(item.media)}
                alt={item.name}
                onError={(e) => (e.target.src = "/img/icon_function_4.png")}
              />
              <div className="info">
                <span className="name">{item.name}</span>
                {item.shortDescription && (
                  <span className="shortDescription">{item.shortDescription}</span>
                )}
                <span className="price">{formatNumber(item.price)}원</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MenuGroupPreviewContainer>
  );
};

export default MenuGroupPreview;
